import {
  Box,
  Button,
  Input,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Text,
  Flex,
  Select,
  Icon,
  ButtonSpinner,
} from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { FaCircle, FaFileExport, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { componentState } from "../../../atoms/componentState";
import { BLUEMONEDDBUTTONS, WHITE } from "../../../constants/colors";
import { useRecoilState, useSetRecoilState } from "recoil";
import moment from "moment";
import SalesListAPI from "../../../services/SalesListApi";
import {
  basicInfo,
  ClientInterface,
  statusInfo,
} from "../../../interfaces/defaultInterfaces";
import SystemApi from "../../../services/systemApi";
import ValueDropdown from "../../../defaultComponents/valueDropdown";
import { LoggedUser } from "../../../atoms/userLogged";
// import ClientFilterSelect from "../../../defaultComponents/ClientFilterSelect";
import jwt_decode from "jwt-decode";
import ModalSalesListDetail from "../../vendas/listaDeVendas/components/modalSaleListDetail";
import CardImageList from "../defaultComponents/tableCardImage";
import { toast } from "react-toastify";
import fileDownload from "js-file-download";
import ExtratoApi from "../../../services/ExtratoAPI";
import { dateForListWithHours } from "../../../constants/dataFormat";
import { customColors } from "../../../atoms/customColors";

interface objetoSalesList {
  bandeira: string;
  bandeiraCartao: string;
  cartaoFim: string;
  cartaoInicio: string;
  clienteNome: string;
  cnpj: string;
  codigoAutorizacao: string;
  codigoAutorizacaoId: string;
  codigoNsu: string;
  dataAtualizacao: string;
  dataCriacao: string;
  dataEstorno: string;
  dataExpiracao: string;
  dataPagamento: string;
  dataReversao: string;
  nulldescricaoEC: string;
  id: number;
  idBandeira: number;
  idCliente: number;
  idCustomer: string;
  idModoPagto: number;
  idPOS: string;
  idPagamento: string;
  idProduto: number;
  idProjeto: number;
  idProvider: number;
  idSeller: string;
  idStatus: number;
  idTransacao: string;
  isCnpj: boolean;
  isCreditCard: boolean;
  modoPagamento: string;
  moeda: string;
  nome: string;
  nomeFantasia: string;
  nomeModoPgto: string;
  nomeProduto: string;
  nomeProjeto: string;
  numeroTransacao: string;
  parcelas: number;
  qrCodePIX: string;
  razaoSocial: string;
  reference_id: number;
  serialPOS: string;
  sobrenome: string;
  status: string;
  statusTransacao: string;
  taxaCliente: number;
  taxaPlano: number;
  urlBoleto: string;
  urlPIX: string;
  valor: number;
  valorLiquido: number;
  valorOriginal: number;
}

export interface JWTToken {
  primarysid: string;
  name: string;
  email: string;
  exp: number;
  idCliente: number;
}

export default function SalesListDashboard({
  dateF,
  setDateF,
  dateI,
  setDateI,
}: any) {
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [pages, setPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [salesList, setSalesList] = useState(Array<objetoSalesList>);
  const [itemDetails, setItemDetails] = useState<objetoSalesList>();
  const [isOpen, setIsOpen] = useState(false);
  const initialValues = {
    clientFilter: 0,
    statusFilter: 0,
    saleTypeFilter: 0,
    initialDateFilter: dateI,
    finalDateFilter: dateF,
    minValueFilter: 0,
    maxValueFilter: 0,
  };
  const [filtros, setFiltros] = useState(initialValues);
  const [disable, setDisable] = useState(false);

  const colors = useRecoilState(customColors)[0];

  const user = useRecoilState(LoggedUser)[0];
  const idUser = user.id;
  const token = window.localStorage.getItem("token");
  let jwtToken: JWTToken = jwt_decode(token || "");
  const navigate = useNavigate();
  const dataInicio = dateI;
  const dataFim = dateF;
  let componentRef = useRef(null);
  let dias = moment(dataFim).diff(dataInicio, "days") >= 32;

  const fontTable = "clamp(12px, 0.8vw, 15px)";
  const fontItems = "clamp(12px, 0.8vw, 15px)";

  async function getSalesListAll() {
    try {
      setLoading(true);
      if (!search) {
        const response = await SalesListAPI.getSalesList(
          1,
          10,
          dataInicio,
          dataFim,
          search,
          Number(jwtToken.idCliente),
          filtros.minValueFilter,
          filtros.maxValueFilter,
          filtros.statusFilter,
          filtros.saleTypeFilter
        );
        setSalesList(response.data);
        setPages(
          Math.ceil(Number(response.headers.totalamountofrecords) / pageSize)
        );
      } else {
        const response = await SalesListAPI.getSalesListDashboard(
          1,
          10,
          search,
          Number(jwtToken.idCliente),
          filtros.minValueFilter,
          filtros.maxValueFilter,
          filtros.statusFilter,
          filtros.saleTypeFilter
        );
        setSalesList(response.data);
        const lenght = response.data.length;
        setPages(Math.ceil(lenght / pageSize));
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  }
  const onChangeSize = (e: any) => {
    setPageSize(e.target.value);
    setCurrentPage(1);
  };
  useEffect(() => {
    if (currentPage > pages) {
      setCurrentPage(1);
      getSalesListAll();
    }
  }, [pages]);
  useEffect(() => {
    getSalesListAll();
  }, [
    search,
    currentPage,
    pageSize,
    filtros.statusFilter,
    filtros.saleTypeFilter,
    filtros.clientFilter,
    filtros.initialDateFilter,
    filtros.finalDateFilter,
    filtros.minValueFilter,
    filtros.maxValueFilter,
    dateI,
    dateF,
  ]);
  const setHeaderLocation = useSetRecoilState(componentState);
  useEffect(() => {
    setHeaderLocation("Lista de Vendas");
  }, []);
  const [clientList, setClientList] = useState(Array<ClientInterface>);
  const [statusList, setStatusList] = useState(Array<statusInfo>);
  const [modoPgtoList, setmodoPgtoList] = useState(Array<basicInfo>);
  const [loadingStatus, setLoadingStatus] = useState(false);

  // async function getClientList() {
  //     try {
  //         const response = await ClientApi.getClients(1, 100, "");
  //         setClientList(response.data);
  //     } catch (error) {
  //         console.log("error", error);
  //     }
  // }
  async function getStatusList() {
    try {
      setLoadingStatus(true);
      const response = await SystemApi.getTransacoesStatus();
      setStatusList(response);
      setLoadingStatus(false);
    } catch (error) {
      console.log("error", error);
      setLoadingStatus(false);
    }
  }
  async function getModoPgtoList() {
    try {
      const response = await SystemApi.getTransacoesModoPagamento();
      setmodoPgtoList(response);
    } catch (error) {
      console.log("error", error);
    }
  }
  useEffect(() => {
    // getClientList();
    getStatusList();
    getModoPgtoList();
  }, []);
  const clientOptions =
    clientList &&
    clientList.map((client) => {
      return {
        key: client.id,
        value: client.id,
        text:
          client?.isCnpj === true
            ? client?.razaoSocial
            : `${client.nome} ${client.sobrenome}`,
      };
    });
  const statusOptions =
    statusList &&
    statusList.map((item) => {
      return {
        key: item.id,
        value: item.id,
        text: item.status,
      };
    });
  const modoPgtoOptions =
    modoPgtoList &&
    modoPgtoList
      .filter((item) => item.id !== 3)
      .map((item) => {
        return {
          key: item.id,
          value: item.id,
          text: item.nome,
        };
      });

  function onChangeClientFilter(e: any) {
    setFiltros({ ...filtros, clientFilter: Number(e.target.value) });
  }
  function onChangeStatusFilter(e: any) {
    setFiltros({ ...filtros, statusFilter: Number(e.target.value) });
  }
  function onChangeModoPgtoFilter(e: any) {
    setFiltros({ ...filtros, saleTypeFilter: Number(e.target.value) });
  }

  async function Export() {
    try {
      setDisable(true);
      const response = await ExtratoApi.exportFile(
        dataInicio,
        dataFim,
        Number(jwtToken.idCliente),
        "",
        filtros.saleTypeFilter,
        filtros.statusFilter
      );
      fileDownload(response, "relatorio.xlsx");
      setDisable(false);
    } catch (error) {
      toast.error("Não foi possível exportar o arquivo!");
    }
  }

  return (
    <Flex flexDir={"column"} maxHeight="100%" maxWidth="100%">
      <Flex
        w={"100%"}
        justifyContent={"center"}
        alignItems="center"
        flexWrap="wrap"
        gap={1}
        textAlign="center"
        fontSize={"clamp(13px, 1vw, 18px)"}
        // mt={"20px"}
      >
        <Text
          color={colors.BLUEMONEDDBUTTONS}
          fontWeight={"bold"}
          textTransform={"uppercase"}
        >
          Faça o seu relatório personalizado:
        </Text>
        <Button
          bg={"none"}
          color={colors.BLUEMONEDDBUTTONS}
          isDisabled={disable || dias}
          onClick={() => {
            Export();
          }}
          mx="10px"
          fontSize={fontItems}
          isLoading={disable}
          textTransform={"uppercase"}
          _hover={{ background: "none" }}
        >
          <Icon mr={2} as={FaFileExport} />
          <Text fontSize={fontItems}>Exporte o seu relatório</Text>
        </Button>
      </Flex>
      <Flex
        w={"100%"}
        justifyContent={"center"}
        alignItems="center"
        // mt={"20px"}
        m={0}
      >
        <Text color={"#CDCDCD"} fontSize={fontItems} fontWeight={"bold"}>
          Buscar pelo ID da transação ou ID de referência
        </Text>
        <Input
          placeholder={"Pesquise o ID"}
          value={search}
          ml={"20px"}
          h={"3.7vh"}
          fontSize={fontItems}
          borderRadius={"20px"}
          background={"white"}
          maxW={"200px"}
          onChange={(e: any) => setSearch(e.target.value)}
        />
      </Flex>
      <Flex
        width={"100%"}
        height={"fit-content"}
        px={3}
        flexDirection={"column"}
        // bgColor={"green"}
      >
        <Flex
          width={"100%"}
          height={"100%"}
          justifyContent="space-evenly"
          // mt={4}

          flexDirection={"column"}
        >
          <Flex
            py={3}
            w={"100%"}
            h={"100%"}
            justifyContent="space-between"
            flexWrap="wrap"
            gap={2}
          >
            <Flex
              flexDir={"column"}
              alignItems={"center"}
              justifyContent="center"
              h={"98%"}
              w={"25%"}
            >
              <Text
                fontWeight={"bold"}
                color={colors.BLUEMONEDDBUTTONS}
                textTransform={"uppercase"}
                fontSize={fontItems}
              >
                Status
              </Text>
              <Select
                placeholder="Status"
                minWidth={"80px"}
                maxW={"100px"}
                bgColor={"white"}
                borderRadius={"20px"}
                color={"gray"}
                fontSize={fontItems}
                h={"30px"}
                value={filtros.statusFilter}
                onChange={onChangeStatusFilter}
              >
                {statusOptions.map((item) => {
                  return (
                    <option value={item.value} key={item.key}>
                      {item.text}
                    </option>
                  );
                })}
              </Select>
            </Flex>
            <Flex
              flexDir={"column"}
              alignItems={"center"}
              justifyContent="center"
              h={"98%"}
              w={"25%"}
            >
              <Text
                fontWeight={"bold"}
                color={colors.BLUEMONEDDBUTTONS}
                textTransform={"uppercase"}
                fontSize={fontItems}
              >
                Tipo de Venda
              </Text>
              <Select
                placeholder="Tipo"
                bgColor={"white"}
                color={"gray"}
                borderRadius={"20px"}
                minWidth={"80px"}
                maxW={"100px"}
                fontSize={fontItems}
                h={"30px"}
                value={filtros.saleTypeFilter}
                onChange={onChangeModoPgtoFilter}
              >
                {modoPgtoOptions.map((item) => {
                  return (
                    <option value={item.value} key={item.key}>
                      {item.text}
                    </option>
                  );
                })}
              </Select>
            </Flex>
            <Flex
              flexDir={"column"}
              alignItems={"center"}
              justifyContent="center"
              h={"98%"}
              w={"25%"}
            >
              <Text
                fontWeight={"bold"}
                color={colors.BLUEMONEDDBUTTONS}
                textTransform={"uppercase"}
                fontSize={fontItems}
              >
                Valor
              </Text>
              <ValueDropdown filtros={filtros} setFiltros={setFiltros} />
            </Flex>
            <Flex
              flexDir={"column"}
              alignItems={"center"}
              h={"98%"}
              w={"25%"}
              justifyContent="center"
            >
              <Text
                fontWeight={"bold"}
                color={colors.BLUEMONEDDBUTTONS}
                textTransform={"uppercase"}
                fontSize={fontItems}
              >
                Limpar
              </Text>
              <Button
                bgColor={"white"}
                color={"gray"}
                minWidth={"100px"}
                maxWidth={"100px"}
                borderRadius={"20px"}
                fontSize={fontItems}
                h={"30px"}
                onClick={() => {
                  setFiltros(initialValues);
                }}
              >
                <Icon as={FaTrash}></Icon>
              </Button>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
      {/* minH em px: 35vh some num ultrawide de 1080p e estoura num 4:3 alto */}
      <Box
        width={"100%"}
        h={"100%"}
        minH={{ base: "260px", md: "300px" }}
        mx="auto"
        mt={1}
        px={4}
        // bgColor={"red"}
        // overflowY={"scroll"}
      >
        <TableContainer borderRadius="8px">
          <Table variant="striped" size="sm">
            <Thead h="clamp(18px, 1.2vw, 28px)">
              <Tr>
                <Th
                  borderRadius={"8px 0 0 8px"}
                  bgColor={colors.BLUEMONEDDBUTTONS}
                  color={colors.WHITE}
                  fontSize={fontTable}
                >
                  Data
                </Th>
                <Th
                  bgColor={colors.BLUEMONEDDBUTTONS}
                  color={colors.WHITE}
                  fontSize={fontTable}
                >
                  Status
                </Th>
                <Th
                  bgColor={colors.BLUEMONEDDBUTTONS}
                  color={colors.WHITE}
                  fontSize={fontTable}
                >
                  Valor Total
                </Th>

                <Th
                  bgColor={colors.BLUEMONEDDBUTTONS}
                  color={colors.WHITE}
                  fontSize={fontTable}
                >
                  Tipo de Venda
                </Th>
                <Th
                  borderRadius={"0 8px 8px 0"}
                  bgColor={colors.BLUEMONEDDBUTTONS}
                  color={colors.WHITE}
                  fontSize={fontTable}
                >
                  Valor Liquido
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {salesList && !loading ? (
                salesList.map((item, index) => {
                  return (
                    <Tr
                      key={index}
                      cursor="pointer"
                      onClick={() => {
                        setIsOpen(true);
                        setItemDetails(item);
                      }}
                    >
                      <Td borderRadius={"8px 0 0 8px"} fontSize={fontTable}>
                        {moment(item.dataCriacao).format(dateForListWithHours)}
                      </Td>
                      <Td fontSize={fontTable}>
                        <Flex flexDirection={"row"}>
                          {(item.status === "succeeded" && (
                            <>
                              <Icon mr={2} as={FaCircle} color={"green"} />{" "}
                              Sucesso
                            </>
                          )) ||
                            (item.status === "pending" && (
                              <>
                                <Icon mr={2} as={FaCircle} color={"yellow"} />{" "}
                                Pendente
                              </>
                            )) ||
                            (item.status === "failed" && (
                              <>
                                <Icon mr={2} as={FaCircle} color={"orange"} />{" "}
                                Falhou
                              </>
                            )) ||
                            (item.status === "new" && (
                              <>
                                <Icon mr={2} as={FaCircle} color={"gray"} />{" "}
                                Nova
                              </>
                            )) ||
                            (item.status === "charged_back" && (
                              <>
                                <Icon mr={2} as={FaCircle} color={"black"} />{" "}
                                ChargeBack{" "}
                              </>
                            )) ||
                            (item.status === "canceled" && (
                              <>
                                <Icon mr={2} as={FaCircle} color={"red"} />{" "}
                                Cancelado{" "}
                              </>
                            )) ||
                            (item.status === "reversed" && (
                              <>
                                <Icon mr={2} as={FaCircle} color={"purple"} />{" "}
                                Revertido{" "}
                              </>
                            )) ||
                            (item.status === "dispute" && (
                              <>
                                <Icon mr={2} as={FaCircle} color={"pink"} /> Em
                                Disputa{" "}
                              </>
                            ))}
                        </Flex>
                      </Td>
                      <Td fontSize={fontTable}>
                        {/* {item.valor
                          ? item.valor.toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            })
                          : "R$ 0,00"} */}
                        <Flex
                          width={"100%"}
                          justifyContent="space-between"
                          alignItems={"center"}
                        >
                          <Text>R$</Text>
                          <Text>
                            {item.valor
                              ? item.valor
                                  .toLocaleString("pt-BR", {
                                    style: "currency",
                                    currency: "BRL",
                                  })
                                  .replace("R$", "")
                              : "0,00"}
                          </Text>
                        </Flex>
                      </Td>

                      <Th fontSize={fontTable} w={"fit-content"}>
                        <CardImageList
                          key={index}
                          text={
                            item.bandeiraCartao
                              ? item.bandeiraCartao
                              : item.bandeira
                          }
                        >
                          {item.bandeiraCartao
                            ? item.bandeiraCartao
                            : item.bandeira}
                        </CardImageList>
                      </Th>
                      <Td borderRadius={"0 8px 8px 0"} fontSize={fontTable}>
                        {/* {item.valorLiquido
                          ? item.valorLiquido.toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            })
                          : item.valorLiquido} */}
                        <Flex
                          width={"100%"}
                          justifyContent="space-between"
                          alignItems={"center"}
                        >
                          <Text>R$</Text>
                          <Text>
                            {item.valorLiquido
                              ? item.valorLiquido
                                  .toLocaleString("pt-BR", {
                                    style: "currency",
                                    currency: "BRL",
                                  })
                                  .replace("R$", "")
                              : "0,00"}
                          </Text>
                        </Flex>
                      </Td>
                    </Tr>
                  );
                })
              ) : (
                <Tr>
                  <Th></Th>
                  <Th></Th>
                  <Th></Th>
                  <Th>
                    <ButtonSpinner />
                  </Th>
                  <Th></Th>
                  <Th></Th>
                  <Th></Th>
                </Tr>
              )}
            </Tbody>
          </Table>
        </TableContainer>
        <ModalSalesListDetail
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          item={itemDetails}
        />
      </Box>
    </Flex>
  );
}
